var map = {
	"./map__pin-acceleration.png": 92356,
	"./map__pin-accident.request.png": 78442,
	"./map__pin-adas.png": 52843,
	"./map__pin-attention.png": 26816,
	"./map__pin-braking.png": 39682,
	"./map__pin-collision-warning.png": 29701,
	"./map__pin-danger-maneuver.png": 38205,
	"./map__pin-door_close.png": 51385,
	"./map__pin-door_open.png": 38861,
	"./map__pin-drinking-water.png": 88152,
	"./map__pin-driver-distraction.png": 85581,
	"./map__pin-drivers-eyes-closed.png": 36867,
	"./map__pin-event.png": 45534,
	"./map__pin-geozone-entrance.png": 52384,
	"./map__pin-geozone-exit.png": 28554,
	"./map__pin-geozone_entrance_control.png": 29020,
	"./map__pin-geozone_exit_control.png": 58078,
	"./map__pin-health_check.done.png": 39637,
	"./map__pin-input-alert.png": 52923,
	"./map__pin-input.png": 6314,
	"./map__pin-left-turn-while-accelerating.png": 65468,
	"./map__pin-left-turn-while-decelerating.png": 15137,
	"./map__pin-left-turn.png": 31511,
	"./map__pin-lost-connection.png": 25033,
	"./map__pin-low-battery.png": 9416,
	"./map__pin-max-speed.png": 82822,
	"./map__pin-no-safety-belt.png": 51114,
	"./map__pin-other.png": 32908,
	"./map__pin-request_done.png": 98922,
	"./map__pin-request_event.png": 60884,
	"./map__pin-request_loading.png": 55784,
	"./map__pin-right-turn-while-accelerating.png": 33399,
	"./map__pin-right-turn-while-decelerating.png": 10666,
	"./map__pin-right-turn.png": 12758,
	"./map__pin-sign-violation.png": 47709,
	"./map__pin-smart-search-accident.request.png": 90785,
	"./map__pin-smart-search.done.png": 59888,
	"./map__pin-smart-search.request.png": 87717,
	"./map__pin-smoking.png": 93680,
	"./map__pin-snapshot.png": 10316,
	"./map__pin-speeding.png": 45832,
	"./map__pin-swerve.png": 35072,
	"./map__pin-talking-on-cell-phone.png": 26800,
	"./map__pin-traffic-light-violation.png": 23200,
	"./map__pin-turn.png": 29461,
	"./map__pin-video-event.png": 55072,
	"./map__pin-yawning.png": 84073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94915;